import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.417 3.75c0-.092.074-.167.166-.167h2v16.833h-2a.167.167 0 0 1-.166-.166zm3.666 16.666V3.583h9.334c.092 0 .166.075.166.167v16.5a.167.167 0 0 1-.166.166zm-.75 1.5h-2.75c-.92 0-1.666-.746-1.666-1.666V3.75c0-.92.746-1.667 1.666-1.667h12.834c.92 0 1.666.746 1.666 1.667v16.5c0 .92-.746 1.666-1.666 1.666z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.25 8.5a.75.75 0 0 1 .75-.75h3.667a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75M11.25 12.167a.75.75 0 0 1 .75-.75h3.667a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75M11.25 16a.75.75 0 0 1 .75-.75h3.667a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }